import classes from './previewScreen.module.scss';

const PreviewScreen = () => {
  return (
    <div className={classes.container}>
      {/* Embeds the Storybook static build served at /storybook/ */}
      {/* In local dev: run `npm run build-storybook` first to populate public/storybook/ */}
      <iframe
        src="/storybook/index.html"
        title="Component Preview"
        className={classes.iframe}
        allowFullScreen
      />
    </div>
  );
};

export default PreviewScreen;
